import { gql } from "@apollo/client";

export const GET_ALL_CATEGORIAS_EFI = gql`
  query allCategoriasEFI {
    allCategoriasEFI {
        idCategoriaEFI
        descripcion
    }
}`;

export const adaptCategoriasEFIArray = (categorias) =>
structuredClone(categorias?.allCategoriasEFI)?.
map((categoria) => ({
  id: categoria?.idCategoriaEFI,
  displayName: categoria?.descripcion
}));